export enum PaymentMethodEnum {
    Card = 'Card',
    Token = 'Token',
}
